<template>
    <div v-if="upsellMonitor" class="monitor">
        <div class="monitor-text">
            <h3>ADD MONITOR?</h3>
            <a class="monitor-button_scroll" v-if="showSeeMonitor" v-scroll-to="'#external-specs'">See Monitor</a>
        </div>
        <div
            @click="toggleMonitor"
            class="monitor-button"
            :class="{ 'monitor-button-active': productInCart, 'disable-element': isUpdating }"
        >
            <img v-show="productInCart" src="images/icons/check-orchid.svg" alt="">
            {{ upsellMonitor.name }} +{{ upsellMonitor.base_price | formatMoney }}
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "MonitorButton",
    props: {
        showSeeMonitor: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            cart: state => state.StarterPc.cart,
            isUpdating: state => state.StarterPc.isUpdating,
            monitors: state => state.StarterPc.accessories.monitors,
            upsellMonitor: state => state.StarterPc.upsellMonitor,
        }),
        productInCart() {
            return this.cart.monitors.find(item => item.products_id == this.upsellMonitor.id);
        }
    },
    methods: {
        ...mapActions({
            removePart: "StarterPc/removePart",
            setSelectedMonitor: "StarterPc/setSelectedMonitor",
            updatePart: "StarterPc/updatePart"
        }),
        toggleMonitor() {
            if (this.productInCart) {
                this.removePart(this.upsellMonitor.variants[0]).then(() => {
                    this.setSelectedMonitor(null);
                });
            } else {
                this.updatePart({ part: this.upsellMonitor.variants[0], qty: 1 }).then(() => {
                    this.setSelectedMonitor(this.upsellMonitor);
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.monitor-button_scroll {
    cursor: pointer;
}

.monitor {
    margin-top: 30px;
    width: 100%;

    @media (max-width: 580px) {
        margin: 30px 0;
    }

    &-text {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        h3 {
            margin: 0;

            @media (max-width: 580px) {
                font-size: 20px;
            }
        }
    }

    a {
        font-size: 16px;
        color: $orchid;

        @media (max-width: 580px) {
            font-size: 14px;
        }
    }

    &-button,
    &-button-active {
        border-radius: 2px;
        font-size: 16px;
        text-align: center;
        padding: 20px 0;
        cursor: pointer;
        transition: .2s;

        @media (max-width: 580px) {
            font-size: 13px;
        }
    }

    &-button {
        border: 3px solid rgba(218,221,224,0.6);

        @media (min-width: 1025px) {
            &:hover {
                border: 3px solid $orchid;
                color: $orchid;
            }
        }

        &-active {
            border: 3px solid $orchid;
            color: $orchid;

            img {
                margin-right: 10px;

                @media (max-width: 580px) {
                    margin-right: 8px;
                }
            }
        }
    }
}

</style>
